<template>
  <div class="gestion-view">
    <v-overlay v-if="loadingInspection">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <h3>Gestion des inspections de la mission</h3>
    <MissionChangeInspectionList
    :mission="selectedMission"
    @listsChange="save($event)">
    </MissionChangeInspectionList>

  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import MissionChangeInspectionList from '../components/missions/MissionChangeInspectionList.vue';

export default {
  components: {
    MissionChangeInspectionList,
  },
  data() {
    return {
      saving: false,
      loadingInspection: false,
    };
  },
  computed: {
    ...mapGetters('missions', { selectedMission: 'selected' }),
    selectedView: {
      get() {
        return this.$store.state.selectedView;
      },
      set(value) {
        this.$store.commit('setSelectedView', value);
      },
    },
  },

  async created() {
    this.loadingInspection = true;
    await this.$store.dispatch('missions/refreshItem', this.selectedMission.id);
    this.selectedView = 'Gestion inspection(s)';
    await Promise.all([
      this.$store.dispatch('inspections/fetchTypesInspectionByMission',
        {
          idMission: this.selectedMission.id,
        }),
    ]);
    this.loadingInspection = false;
  },

  methods: {
    save(event) {
      this.saving = true;
      const payload = { };
      payload.id = this.selectedMission.id;
      payload.data = {
        authorizedInspectionSite: event.siteInspection,
        authorizedInspectionBatiment: event.batimentInspection,
      };

      this.$store.dispatch(
        'missions/save',
        {
          id: payload.id,
          ...payload,
        },
      ).then((res) => {
        if (res.isAxiosError) {
          const message = 'Impossible de sauvegarder les changements';
          this.$store.dispatch('snackbar/displaySnack',
            {
              message,
              type: 'error',
            });
        } else {
          this.$store.dispatch('snackbar/displaySnack', { message: 'Sauvegardé avec succès !', type: 'succes' });
        }
      }).catch(() => {
        const message = 'Impossible de sauvegarder les changements';
        this.$store.dispatch('snackbar/displaySnack',
          {
            message,
            type: 'error',
          });
      }).finally(() => {
        this.saving = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .gestion-view {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: center;

    padding: 1rem;

    > * {
      margin-bottom: 2rem;
    }
  }
  .combox {
    width:34em;
  }
</style>
